import {generatePath} from 'react-router-dom';
import {compact, isString} from 'lodash/fp';

import {
  CarrierLevel,
  CompanyViewType,
  IndustryLevel,
  IntermediaryLevel,
  ProductLevel,
} from 'modules/decisionsNext/api/types';
import {CustomReportType} from 'pages/reportStudio/ReportsCustomReportPage/reportBuilder/types';
import {CustomReportMode} from 'modules/decisionsNext/types';
import {SearchByType} from 'modules/growth/pages/OpportunitiesNetNewPage/types';

export type EntityLevel = IndustryLevel | ProductLevel | CompanyViewType;

export const ENNABL_IMPERSONATE = '/impersonate';
export const IMPERSONATION = 'impersonation';

export const PDF_REPORTS = 'pdf-reports';
export const PDF_REPORTS_CARRIER_V1 = 'carrier/v1';
export const PDF_ACCOUNT_LOCATION_V1 = 'account-location/v1';
export const PDF_REPORTS_LOSS_RUNS_V1 = 'loss-runs/v1';
export const PDF_REPORTS_PROPOSAL_GENERATION_V1 = 'proposal-generation/v1';
export const MOCK_DATA = 'mock-data';
// Path for the latest version of carrier PDF report. Change this path to the latest version when it's available
export const CARRIER_REPORT_PATH = `${PDF_REPORTS}/${PDF_REPORTS_CARRIER_V1}`;
export const LOCATION_REPORT_PATH = `${PDF_REPORTS}/${PDF_ACCOUNT_LOCATION_V1}`;
export const LOSS_RUNS_REPORT_PATH = `${PDF_REPORTS}/${PDF_REPORTS_LOSS_RUNS_V1}`;

export const ENNABL_COMMAND = '/command';
export const ENNABL_LOSS_RUNS = '/loss-runs';
export const ENNABL_LOSS_RUNS_SHARED_TAB = '/loss-runs?-Tab=shared';
export const ENNABL_DECISIONS = '/decisions';
export const ENNABL_DOCUMENTS = '/documents';
export const ENNABL_WORKFLOWS = '/workflows';
export const ENNABL_PRIVACY_POLICY = '/privacy-policy';

export const DECISIONS_PAGES = `${ENNABL_DECISIONS}/pages`;
export const KPI = 'kpi';
export const ACCOUNT_MANAGER = 'account-manager';
export const ACCOUNT_MANAGERS = 'account-managers';
export const ACCOUNT_EXECUTIVE = 'account-executive';
export const ACCOUNT_EXECUTIVES = 'account-executives';
export const ACCOUNTS = 'accounts';
export const ACCOUNT = 'account';
export const ACTIVITIES = 'activities';
export const ACTIVITY = 'activity';
export const ACTIVITY_EMPLOYEE = 'activity-employee';
export const ALERTS = 'alerts';
export const PROSPECTS = 'prospects';
export const PROSPECT = 'prospect';
export const AVERAGE_ACCOUNT_SIZE = 'avg-account-size';
export const PREMIUM_SIZE = 'premium-size';
export const AVERAGE_PER_CLIENT = 'avg-per-client';
export const AVERAGE_PRODUCTS_PER_CLIENT = 'avg-products-per-client';
export const EMPLOYEES_RELATIONSHIPS = 'employees-relationships';
export const TOP_PRODUCTS = 'top-products';
export const TOP_INDUSTRIES = 'top-industries';
export const TOP_CARRIERS = 'top-carriers';
export const BY_PRODUCTS = 'by-products';
export const BY_PRODUCT = 'by-product';
export const BY_INDUSTRIES = 'by-industries';
export const BY_CARRIER = 'by-carrier';
export const BOOK_PERFORMANCE = 'book-performance';
export const CARRIER_APPETITE = 'carrier-appetite';
export const CLIENT_SIZE = 'client-size';
export const COMPARISON_PERIODS = 'comparison-periods';
export const POLICIES = 'policies';
export const RETENTION = 'retention';
export const PREMIUM_FLOW = 'premium-flow';
export const LEADERBOARD = 'leaderboard';
export const GROWTH = 'growth';
export const OPPORTUNITIES = 'opportunities';
export const HOME = 'home';
export const MARKETS = 'markets';
export const DECISIONS_PAGES_OPPORTUNITIES = `${DECISIONS_PAGES}/${OPPORTUNITIES}`;
export const OPPORTUNITY_FINDER = 'opportunity-finder';
export const DECISIONS_PAGES_OPPORTUNITIES_OPPORTUNITIES_FINDER = `${DECISIONS_PAGES}/${OPPORTUNITIES}/${OPPORTUNITY_FINDER}`;
export const REPORTS = 'reports';
export const DOCUMENTS = 'documents';
export const PRODUCER = 'producer';
export const PRODUCERS = 'producers';
export const SEARCH = `search`;
export const PRODUCT = 'product';
export const PRODUCT_GROUP = 'product-group';
export const PRODUCT_SUPER_GROUP = 'product-super-group';
export const PRODUCT_INSURANCE_SEGMENT = 'product-insurance-segment';
export const PRODUCTS = 'products';
export const MONOLINE_RATIOS = 'monoline-ratios';
export const SHOW_MORE = 'show-more-table';

export const O360SCORE = 'o360score';
export const INDUSTRIES = 'industries';
export const INDUSTRY = 'industry';
export const INDUSTRY_GROUP = 'industry-group';
export const INDUSTRY_SUBGROUP = 'industry-subgroup';
export const SHARE_FILTERS = 'share-filters';
export const WHATS_NEW = 'whats-new';

export const DECISIONS_PAGES_NEW_BUSINESS_PRODUCERS = `${ENNABL_DECISIONS}/new-business-producers`;
export const DECISIONS_PAGES_NEW_BUSINESS_PRODUCER = `${ENNABL_DECISIONS}/new-business-producer`;
export const RENEWALS = 'renewals';
export const DECISIONS_PAGES_RENEWALS = `${DECISIONS_PAGES}/${RENEWALS}`;
export const DECISIONS_PAGES_ACCOUNT_MANAGERS_RENEWALS = `${ENNABL_DECISIONS}/${ACCOUNT_MANAGERS}/${RENEWALS}`;
export const DECISIONS_PAGES_ACCOUNT_MANAGERS_ACCOUNT_MANAGERS = `${ENNABL_DECISIONS}/${ACCOUNT_MANAGERS}/${ACCOUNT_MANAGERS}`;
export const DECISIONS_REPORTS = `${ENNABL_DECISIONS}/${REPORTS}`;
export const DECISIONS_DOCUMENTS = `${ENNABL_DECISIONS}/${DOCUMENTS}`;
export const DECISIONS_KPI = `${ENNABL_DECISIONS}/${KPI}`;
export const CUSTOM_REPORT = 'custom-report';
export const QUERY_REPORT = 'query-report';
export const DECISIONS_REPORTS_CUSTOM_REPORT = `${DECISIONS_REPORTS}/${CUSTOM_REPORT}`;
export const DECISIONS_WHATS_NEW = `${ENNABL_DECISIONS}/${WHATS_NEW}`;

export const DECISIONS_CARRIER_APPETITE = `${ENNABL_DECISIONS}/${CARRIER_APPETITE}`;
export const DECISIONS_PRODUCERS = `${ENNABL_DECISIONS}/${PRODUCERS}`;
export const DECISIONS_PRODUCER = `${ENNABL_DECISIONS}/${PRODUCER}`;
export const DECISIONS_ACCOUNTS = `${ENNABL_DECISIONS}/${ACCOUNTS}`;
export const DECISIONS_PROSPECTS = `${ENNABL_DECISIONS}/${PROSPECTS}`;
export const DECISIONS_ACCOUNTS_ACCOUNTS = `${ENNABL_DECISIONS}/${ACCOUNTS}/${ACCOUNTS}`;
export const DECISIONS_ACCOUNTS_LOST = `${ENNABL_DECISIONS}/${ACCOUNTS}/lost`;
export const DECISIONS_ACCOUNT_MANAGER = `${ENNABL_DECISIONS}/${ACCOUNT_MANAGER}`;
export const DECISIONS_ACCOUNT_EXECUTIVE = `${ENNABL_DECISIONS}/${ACCOUNT_EXECUTIVE}`;
export const DECISIONS_MARKETS = `${ENNABL_DECISIONS}/markets`;
export const DECISIONS_ACCOUNT_EXECUTIVES = `${ENNABL_DECISIONS}/${ACCOUNT_EXECUTIVES}`;
export const DECISIONS_ACCOUNT_MANAGERS = `${ENNABL_DECISIONS}/${ACCOUNT_MANAGERS}`;
export const DECISIONS_INDUSTRIES = `${ENNABL_DECISIONS}/${INDUSTRIES}`;
export const DECISIONS_INDUSTRY = `${ENNABL_DECISIONS}/${INDUSTRY}`;
export const DECISIONS_INDUSTRY_GROUP = `${ENNABL_DECISIONS}/${INDUSTRY_GROUP}`;
export const DECISIONS_INDUSTRY_SUBGROUP = `${ENNABL_DECISIONS}/${INDUSTRY_SUBGROUP}`;
export const DECISIONS_PRODUCT = `${ENNABL_DECISIONS}/${PRODUCT}`;
export const DECISIONS_PRODUCTS = `${ENNABL_DECISIONS}/products`;
export const DECISIONS_PRODUCT_GROUP = `${ENNABL_DECISIONS}/product-group`;
export const DECISIONS_PRODUCT_SUPER_GROUP = `${ENNABL_DECISIONS}/product-super-group`;
export const DECISIONS_PRODUCT_INSURANCE_SEGMENT = `${ENNABL_DECISIONS}/${PRODUCT_INSURANCE_SEGMENT}`;
export const DECISIONS_CLIENT = `${ENNABL_DECISIONS}/client`;
export const DECISIONS_PROSPECT = `${ENNABL_DECISIONS}/${PROSPECT}`;
export const DECISIONS_ACCOUNT = `${ENNABL_DECISIONS}/${ACCOUNT}`;
export const DECISIONS_O360SCORE = `${ENNABL_DECISIONS}/${O360SCORE}`;
export const DECISIONS_O360SCORE_PRODUCER_URL = `${ENNABL_DECISIONS}/${O360SCORE}/:id`;
export const DECISIONS_MONOLINE_RATIOS = `${ENNABL_DECISIONS}/${MONOLINE_RATIOS}`;
export const DECISIONS_ACTIVITIES = `${ENNABL_DECISIONS}/${ACTIVITIES}`;
export const DECISIONS_ACTIVITY = `${ENNABL_DECISIONS}/${ACTIVITY}`;
export const DECISIONS_EMPLOYEE_ACTIVITY = `${ENNABL_DECISIONS}/${ACTIVITY_EMPLOYEE}`;

export const DECISIONS_MONOLINE_RATIOS_ENTITY_URL = `${ENNABL_DECISIONS}/${MONOLINE_RATIOS}/:entity/:id`;
export const DECISIONS_PRODUCER_URL = `${DECISIONS_PRODUCER}/:id`;
export const DECISIONS_ACCOUNT_EXECUTIVE_URL = `${DECISIONS_ACCOUNT_EXECUTIVE}/:id`;
export const DECISIONS_ACCOUNT_MANAGER_URL = `${DECISIONS_ACCOUNT_MANAGER}/:id`;
export const DECISIONS_PRODUCT_URL = `${DECISIONS_PRODUCT}/:id`;
export const DECISIONS_PRODUCT_GROUP_URL = `${DECISIONS_PRODUCT_GROUP}/:id`;
export const DECISIONS_PRODUCT_SUPER_GROUP_URL = `${DECISIONS_PRODUCT_SUPER_GROUP}/:id`;
export const DECISIONS_PRODUCT_INSURANCE_SEGMENT_URL = `${DECISIONS_PRODUCT_INSURANCE_SEGMENT}/:id`;
export const DECISIONS_INDUSTRY_SUBGROUP_URL = `${DECISIONS_INDUSTRY_SUBGROUP}/:id`;
export const DECISIONS_INDUSTRY_GROUP_URL = `${DECISIONS_INDUSTRY_GROUP}/:id`;
export const DECISIONS_INDUSTRY_URL = `${DECISIONS_INDUSTRY}/:id`;
export const DECISIONS_PROSPECT_URL = `${DECISIONS_PROSPECT}/:id`;
export const DECISIONS_ACCOUNT_URL = `${DECISIONS_ACCOUNT}/:id`;
export const DECISIONS_ACCOUNT_ALERTS_URL = `${DECISIONS_ACCOUNT}/:id/${ALERTS}`;
export const DECISIONS_ACTIVITY_URL = `${DECISIONS_ACTIVITY}/:id`;
export const DECISIONS_EMPLOYEE_ACTIVITY_URL = `${DECISIONS_EMPLOYEE_ACTIVITY}/:id`;

export const DECISIONS_ACCOUNT_MANAGERS_TOP_CARRIERS = `${ENNABL_DECISIONS}/${ACCOUNT_MANAGERS}/${TOP_CARRIERS}`;
export const DECISIONS_ACCOUNT_MANAGERS_TOP_INDUSTRIES = `${ENNABL_DECISIONS}/${ACCOUNT_MANAGERS}/${TOP_INDUSTRIES}`;
export const DECISIONS_ACCOUNT_MANAGERS_TOP_PRODUCTS = `${ENNABL_DECISIONS}/${ACCOUNT_MANAGERS}/${TOP_PRODUCTS}`;
export const DECISIONS_SHARE_FILTERS = `${ENNABL_DECISIONS}/${SHARE_FILTERS}/:id`;
export const DECISIONS_RETENTION = `${ENNABL_DECISIONS}/${RETENTION}`;

export const GOALS = 'goals';
const LISTS = 'lists';
const REMINDERS = 'reminders';

export const ENNABL_GROWTH = '/growth';
export const MY_GROWTH_ID = 'my';
export const GROWTH_OPPORTUNITIES = `${ENNABL_GROWTH}/${MY_GROWTH_ID}/${OPPORTUNITIES}`;
export const GROWTH_LISTS = `${ENNABL_GROWTH}/${MY_GROWTH_ID}/${LISTS}`;
export const GROWTH_REMINDERS = `${ENNABL_GROWTH}/${MY_GROWTH_ID}/${REMINDERS}`;
export const GROWTH_GOALS = `${ENNABL_GROWTH}/${MY_GROWTH_ID}/${GOALS}`;
export const GROWTH_CARRIER_APPETITE = `${ENNABL_GROWTH}/${MY_GROWTH_ID}/${CARRIER_APPETITE}`;

export const ENNABL_CHAT_AI = '/chat-ai';
export const ENNABL_AI_MIGRATION = '/ennabl-ai';

const standalonePagePaths = {
  workflows: ENNABL_WORKFLOWS,
  documents: DECISIONS_DOCUMENTS,
  'all-markets': DECISIONS_MARKETS,
  'all-account-managers': DECISIONS_ACCOUNT_MANAGERS,
  'all-account-executives': DECISIONS_ACCOUNT_EXECUTIVES,
  'all-producers': DECISIONS_PRODUCERS,
  'all-products': DECISIONS_PRODUCTS,
  'all-accounts': DECISIONS_ACCOUNTS,
  'all-industries': DECISIONS_INDUSTRIES,
  'all-monoline-ratios': DECISIONS_MONOLINE_RATIOS,
  'carrier-appetite': DECISIONS_CARRIER_APPETITE,
  'producer-goals': DECISIONS_PAGES_NEW_BUSINESS_PRODUCERS,
  'loss-runs': ENNABL_LOSS_RUNS,
  kpi: DECISIONS_KPI,
  renewals: DECISIONS_PAGES_RENEWALS,
  reports: DECISIONS_REPORTS,
  growth: ENNABL_GROWTH,
  retention: DECISIONS_RETENTION,
  'all-activities': DECISIONS_ACTIVITIES,
  'whats-new': DECISIONS_WHATS_NEW,
} as const;

type ComplexPathUrlProps = {
  url: string;
};
type ComplexPathTabsProps = {
  tab?: string | null;
  subTab?: string | null;
};
type ComplexPathIdProps = {
  id: string;
};
type ComplexPathSearchParamsProps = {
  searchParams?: {key: string; value?: string | null}[];
};
export type MarketTypeProps = {
  type?: MarketType;
};

export const MARKET = 'market';

export const DECISIONS_MARKET_URL_BASE = `${ENNABL_DECISIONS}/${MARKET}/:category/:id`;
const DECISIONS_MARKET_URL = `${DECISIONS_MARKET_URL_BASE}/:type`;

export enum MarketCategory {
  ULTIMATE = 'ultimate',
  PARENT = 'parent',
  CHILD = 'child',
}

export enum MarketType {
  ICO = 'ico',
  BCO = 'bco',
  INTERMEDIARY = 'intermediary',
}

function generateDecisionsMarketPath(params: {id: string; category: MarketCategory; type: MarketType}) {
  return generatePath(DECISIONS_MARKET_URL, {
    ...params,
    id: encodeURIComponent(params.id),
  });
}

export function generateDecisionsUltimateIntermediaryPath(pathProps: ComplexPathIdProps) {
  return generateDecisionsMarketPath({
    id: pathProps.id,
    category: MarketCategory.ULTIMATE,
    type: MarketType.INTERMEDIARY,
  });
}

export function generateDecisionsParentIntermediaryPath(pathProps: ComplexPathIdProps) {
  return generateDecisionsMarketPath({
    id: pathProps.id,
    category: MarketCategory.PARENT,
    type: MarketType.INTERMEDIARY,
  });
}

export function generateDecisionsIntermediaryPath(pathProps: ComplexPathIdProps) {
  return generateDecisionsMarketPath({
    id: pathProps.id,
    category: MarketCategory.CHILD,
    type: MarketType.INTERMEDIARY,
  });
}

export function generateDecisionsUltimateCarrierPath(pathProps: ComplexPathIdProps & MarketTypeProps) {
  return generateDecisionsMarketPath({
    id: pathProps.id,
    category: MarketCategory.ULTIMATE,
    type: pathProps.type ?? MarketType.ICO,
  });
}

export function generateDecisionsParentCarrierPath(pathProps: ComplexPathIdProps & MarketTypeProps) {
  return generateDecisionsMarketPath({
    id: pathProps.id,
    category: MarketCategory.PARENT,
    type: pathProps.type ?? MarketType.ICO,
  });
}

export function generateDecisionsIssuingPaperCarrierPath(pathProps: ComplexPathIdProps & MarketTypeProps) {
  return generateDecisionsMarketPath({
    id: pathProps.id,
    category: MarketCategory.CHILD,
    type: pathProps.type ?? MarketType.ICO,
  });
}

type GeneratePathProps = ComplexPathTabsProps & ComplexPathIdProps & ComplexPathUrlProps & ComplexPathSearchParamsProps;
export type DecisionsPathProps = ComplexPathTabsProps & ComplexPathIdProps & ComplexPathSearchParamsProps;

const generateComplexPath = ({
  url,
  tab,
  subTab,
  searchParams,
}: ComplexPathTabsProps & ComplexPathUrlProps & ComplexPathSearchParamsProps) => {
  if (searchParams) {
    return `${url}?${searchParams
      .filter(({value}) => value)
      .map(({key, value}) => `${key}=${value}`)
      .join('&')}`;
  }

  const complexUrl = [url, tab].filter(isString).join('/');
  return subTab ? `${complexUrl}?tab=${subTab}` : complexUrl;
};

const generateDecisionsPath = ({url, id, ...pathProps}: GeneratePathProps) => {
  return generateComplexPath({url: generatePath(url, {id: encodeURIComponent(id)}), ...pathProps});
};

export function generateStandalonePagePath({id, ...pathProps}: DecisionsPathProps) {
  return generateComplexPath({...pathProps, url: getStandalonePagePath(id as keyof typeof standalonePagePaths)});
}

export function generateDecisionsProducerPath(pathProps: DecisionsPathProps) {
  return generateDecisionsPath({...pathProps, url: DECISIONS_PRODUCER_URL});
}

export function generateDecisionsAccountExecutivePath(pathProps: DecisionsPathProps) {
  return generateDecisionsPath({...pathProps, url: DECISIONS_ACCOUNT_EXECUTIVE_URL});
}

export function generateDecisionsAccountManagerPath(pathProps: DecisionsPathProps) {
  return generateDecisionsPath({...pathProps, url: DECISIONS_ACCOUNT_MANAGER_URL});
}

export function generateDecisionsProductPath(pathProps: DecisionsPathProps) {
  return generateDecisionsPath({...pathProps, url: DECISIONS_PRODUCT_URL});
}

export function generateDecisionsProductGroupPath(pathProps: DecisionsPathProps) {
  return generateDecisionsPath({...pathProps, url: DECISIONS_PRODUCT_GROUP_URL});
}

export function generateDecisionsProductSuperGroupPath(pathProps: DecisionsPathProps) {
  return generateDecisionsPath({...pathProps, url: DECISIONS_PRODUCT_SUPER_GROUP_URL});
}

export function generateDecisionsProductInsuranceSegmentPath(pathProps: DecisionsPathProps) {
  return generateDecisionsPath({...pathProps, url: DECISIONS_PRODUCT_INSURANCE_SEGMENT_URL});
}

export function generateDecisionsIndustryPathByLevel(pathProps: DecisionsPathProps & {level: IndustryLevel}) {
  return industryPathGenByLevel[pathProps.level](pathProps);
}

function generateDecisionsIndustryPath(pathProps: DecisionsPathProps) {
  return generateDecisionsPath({...pathProps, url: DECISIONS_INDUSTRY_URL});
}

function generateDecisionsIndustryGroupPath(pathProps: DecisionsPathProps) {
  return generateDecisionsPath({...pathProps, url: DECISIONS_INDUSTRY_GROUP_URL});
}

function generateDecisionsIndustrySubGroupPath(pathProps: DecisionsPathProps) {
  return generateDecisionsPath({...pathProps, url: DECISIONS_INDUSTRY_SUBGROUP_URL});
}

export function generateDecisionsO360ProducerScorePath(pathProps: DecisionsPathProps) {
  return generateDecisionsPath({...pathProps, url: DECISIONS_O360SCORE_PRODUCER_URL});
}

export function generateDecisionsAccountPath(pathProps: DecisionsPathProps) {
  return generateDecisionsPath({...pathProps, url: DECISIONS_ACCOUNT_URL});
}

export function generateDecisionsAccountAlertsPath(pathProps: DecisionsPathProps) {
  return generateDecisionsPath({...pathProps, url: DECISIONS_ACCOUNT_ALERTS_URL});
}

export function generateDecisionsActivityPath(pathProps: DecisionsPathProps) {
  return generateDecisionsPath({...pathProps, url: DECISIONS_ACTIVITY_URL});
}

export function generateDecisionsEmployeeActivityPath(pathProps: DecisionsPathProps) {
  return generateDecisionsPath({...pathProps, url: DECISIONS_EMPLOYEE_ACTIVITY_URL});
}

export enum MonolineRatiosEntityType {
  Market = 'market',
  Producer = 'producer',
  Product = 'product',
  Department = 'department',
}

export function generateDecisionsMonolineRatiosEntityPath(params: {id: string; entity: MonolineRatiosEntityType}) {
  return generatePath(DECISIONS_MONOLINE_RATIOS_ENTITY_URL, {
    ...params,
    id: encodeURIComponent(params.id),
  });
}

export type DecisionsPathTypes =
  | 'client'
  | 'market'
  | 'intermediary'
  | 'company'
  | 'product'
  | 'producer'
  | 'industry'
  | 'prospect';

export function generateDecisionsPathByType(
  type: DecisionsPathTypes,
  pathProps: DecisionsPathProps,
  level?: EntityLevel
) {
  switch (type) {
    case 'client':
      return generateDecisionsAccountPath(pathProps);

    case 'industry': {
      if (!level) {
        return '#';
      }

      return industryPathGenByLevel[level as IndustryLevel](pathProps);
    }

    case 'market': {
      if (!level) {
        return '#';
      }

      return carrierPathGenByType[
        level as CompanyViewType.UltimateParentCarrier | CompanyViewType.ParentCarrier | CompanyViewType.IssuingPaper
      ](pathProps);
    }

    case 'intermediary': {
      if (!level) {
        return '#';
      }

      return intermediaryPathGenByType[
        level as
          | CompanyViewType.UltimateParentIntermediary
          | CompanyViewType.ParentIntermediary
          | CompanyViewType.Intermediary
      ](pathProps);
    }

    case 'company':
      if (!level) {
        return '#';
      }

      return companyPathGenByType[level as CompanyViewType](pathProps);
    case 'product':
      return generateDecisionsProductPath(pathProps);
    case 'producer':
      return generateDecisionsProducerPath(pathProps);
    case 'prospect':
      return generateDecisionsProducerPath(pathProps);
    default:
      throw new Error(`Unknown decisions path type: ${type}`);
  }
}

/**
 * Construct a link to industry page.
 *
 * This is a low-level map, and it shouldn't be used directly. Use {@link generateDecisionsIndustryPathByLevel} instead
 *
 * @deprecated this is NOT a deprecation warning. This is a warning that you probably don't
 * want to use this map directly
 */
export const industryPathGenByLevel = {
  [IndustryLevel.Group]: generateDecisionsIndustryGroupPath,
  [IndustryLevel.SubGroup]: generateDecisionsIndustrySubGroupPath,
  [IndustryLevel.Industry]: generateDecisionsIndustryPath,
};

export const intermediaryPathGenByType = {
  [CompanyViewType.UltimateParentIntermediary]: generateDecisionsUltimateIntermediaryPath,
  [CompanyViewType.ParentIntermediary]: generateDecisionsParentIntermediaryPath,
  [CompanyViewType.Intermediary]: generateDecisionsIntermediaryPath,
};

export const carrierPathGenByType = {
  [CompanyViewType.UltimateParentCarrier]: generateDecisionsUltimateCarrierPath,
  [CompanyViewType.ParentCarrier]: generateDecisionsParentCarrierPath,
  [CompanyViewType.IssuingPaper]: generateDecisionsIssuingPaperCarrierPath,
};

export const companyPathGenByType = {
  ...intermediaryPathGenByType,
  ...carrierPathGenByType,
};

export const carrierLevelToCompanyView = {
  [CarrierLevel.UltimateParentCarrier]: CompanyViewType.UltimateParentCarrier,
  [CarrierLevel.ParentCarrier]: CompanyViewType.ParentCarrier,
  [CarrierLevel.IssuingPaper]: CompanyViewType.IssuingPaper,
};

export const intermediaryLevelToCompanyView = {
  [IntermediaryLevel.UltimateParentIntermediary]: CompanyViewType.UltimateParentIntermediary,
  [IntermediaryLevel.ParentIntermediary]: CompanyViewType.ParentIntermediary,
  [IntermediaryLevel.ChildIntermediary]: CompanyViewType.Intermediary,
};

export const getCarrierPathGenByLevel = (availableViewModes?: CompanyViewType[], carrierLevel?: CarrierLevel) => {
  const level =
    carrierLevel && availableViewModes?.includes(carrierLevelToCompanyView[carrierLevel])
      ? carrierLevelToCompanyView[carrierLevel]
      : availableViewModes?.[0];

  return level ? companyPathGenByType[level] : undefined;
};

export const getMGACarrierPathGenByLevel = (availableViewModes?: CompanyViewType[], carrierLevel?: CarrierLevel) => {
  if (!mgaCarrierViewTypes.some(viewMode => availableViewModes?.includes(viewMode))) {
    return () => '';
  }

  return carrierLevel ? mgaCarrierPathGenByType[carrierLevel] : generateDashboardUltimateCarrierPath;
};

export const getIntermediaryPathGenByLevel = (
  availableViewModes?: CompanyViewType[],
  intermediaryLevel?: IntermediaryLevel
) => {
  const level =
    intermediaryLevel && availableViewModes?.includes(intermediaryLevelToCompanyView[intermediaryLevel])
      ? intermediaryLevelToCompanyView[intermediaryLevel]
      : availableViewModes?.[0];

  return level ? intermediaryPathGenByType[level as keyof typeof intermediaryPathGenByType] : undefined;
};

export const getStandalonePagePath = (pageId: keyof typeof standalonePagePaths) => {
  if (!standalonePagePaths[pageId]) {
    return ENNABL_DECISIONS;
  }

  return standalonePagePaths[pageId];
};

export function generateOpportunitiesCompanySearchPath({
  companyName,
  searchBy,
  industries,
  state,
  country,
  county,
}: {
  companyName?: string;
  searchBy?: SearchByType;
  industries?: string;
  state?: string;
  country?: string;
  county?: string;
} = {}) {
  const searchParams = new URLSearchParams();
  searchParams.append('tab', 'company-search');

  if (companyName) {
    searchParams.append('companyName', companyName);
  }

  if (searchBy) {
    searchParams.append('searchBy', searchBy);
  }

  if (industries) {
    searchParams.append('industries', industries);
  }

  if (country) {
    searchParams.append('country', country);
  }

  if (state) {
    searchParams.append('state', state);
  }

  if (county) {
    searchParams.append('county', county);
  }

  return `${DECISIONS_PAGES_OPPORTUNITIES}/${OPPORTUNITY_FINDER}?${searchParams.toString()}`;
}

export function generateDecisionsProspectPath(pathProps: DecisionsPathProps) {
  return generateDecisionsPath({...pathProps, url: DECISIONS_PROSPECT_URL});
}

export function generateDecisionsCustomReportPath({
  reportType,
  mode,
  ...pathProps
}: DecisionsPathProps & {
  reportType: CustomReportType;
  mode?: CustomReportMode;
}) {
  return generateDecisionsPath({
    ...pathProps,
    url: `${DECISIONS_REPORTS}/${CUSTOM_REPORT}/:id`,
    searchParams: compact([{key: 'type', value: reportType}, mode && {key: 'mode', value: mode}]),
  });
}

export function generateDecisionsQueryReportPath(id: string) {
  return generateDecisionsPath({
    id,
    url: `${DECISIONS_REPORTS}/${QUERY_REPORT}/:id`,
  });
}

export function generateDecisionsShareFiltersPath(pathProps: DecisionsPathProps) {
  return generateDecisionsPath({...pathProps, url: DECISIONS_SHARE_FILTERS});
}

export function generateDecisionsHomeSectionShowMorePath({dashboard, section}: {dashboard: string; section: string}) {
  return generatePath(`${ENNABL_DECISIONS}/${HOME}/:dashboard/:section`, {
    section: encodeURIComponent(section),
    dashboard: encodeURIComponent(dashboard),
  });
}

// LOSS RUNS
export const SUMMARY = 'summary';
export const OPEN_CLAIMS = 'open-claims';
export const TOP_INCURRED = 'top-incurred';
export const TOTAL_INCURRED = 'total-incurred';
export const FREQUENCY_SEVERITY = 'frequency-severity';
export const USER_INPUT = 'user-input';
export const CLAIMS_BY_TYPE = 'claims-by-claim-type';
export const TOTAL_INCURRED_BY_DEPARTMENT = 'total-incurred-by-department';
export const TOTAL_INCURRED_BY_MACHINE = 'total-incurred-by-machine';
export const TOTAL_INCURRED_BY_OCCUPATION = 'total-incurred-by-occupation';
export const TENURE_ANALYSIS = 'tenure-analysis';
export const TENURE_COHORT_ANALYSIS = 'tenure-cohort-analysis';

const LOSS_RUNS_BATCH_PAGE = `${ENNABL_LOSS_RUNS}/:id`;
const LOSS_RUNS_SHARED_BATCH_PAGE = `${ENNABL_LOSS_RUNS}/shared/:id`;
const LOSS_RUNS_BATCH_SUMMARY_PRODUCT_PAGE = `${LOSS_RUNS_BATCH_PAGE}/${SUMMARY}/:product`;
const LOSS_RUNS_SHARED_BATCH_SUMMARY_PRODUCT_PAGE = `${LOSS_RUNS_SHARED_BATCH_PAGE}/${SUMMARY}/:product`;
const LOSS_RUNS_BATCH_USER_INPUT_PAGE = `${LOSS_RUNS_BATCH_PAGE}/${USER_INPUT}/:fileId`;
const LOSS_RUNS_SHARED_BATCH_USER_INPUT_PAGE = `${LOSS_RUNS_SHARED_BATCH_PAGE}/${USER_INPUT}/:fileId`;

export function generateLossRunsBatchPagePath(id: string, shared?: boolean) {
  return generatePath(shared ? LOSS_RUNS_SHARED_BATCH_PAGE : LOSS_RUNS_BATCH_PAGE, {id: encodeURIComponent(id)});
}

export function generateLossRunsBatchSummaryProductPagePath({
  id,
  product,
  shared,
}: ComplexPathIdProps & {product: string; shared?: boolean}) {
  return generatePath(shared ? LOSS_RUNS_SHARED_BATCH_SUMMARY_PRODUCT_PAGE : LOSS_RUNS_BATCH_SUMMARY_PRODUCT_PAGE, {
    id: encodeURIComponent(id),
    product: encodeURIComponent(product),
  });
}

export function generateLossRunsBatchUserInputPagePath({
  fileId,
  id,
  shared,
}: {
  id: string;
  fileId?: string;
  shared?: boolean;
}) {
  return generatePath(shared ? LOSS_RUNS_SHARED_BATCH_USER_INPUT_PAGE : LOSS_RUNS_BATCH_USER_INPUT_PAGE, {
    id: encodeURIComponent(id),
    fileId: fileId ? encodeURIComponent(fileId) : '',
  });
}

// DOCUMENTS

export const LIBRARY = 'library';
export const COMPARE = 'compare';

export const DOCUMENTS_LIBRARY = `${ENNABL_DOCUMENTS}/${LIBRARY}`;
export const DOCUMENTS_COMPARE = `${ENNABL_DOCUMENTS}/${COMPARE}`;

export const generateLibraryDocumentPagePath = (id: string) => {
  return generatePath(`${DOCUMENTS_LIBRARY}/:id`, {id: encodeURIComponent(id)});
};

export const generateLibraryFolderPagePath = (folder: string) => {
  return generatePath(`${DOCUMENTS_LIBRARY}/folder/:folder`, {folder: encodeURIComponent(folder)});
};

export const generateCompareGroupPagePath = (id: string) => {
  return generatePath(`${DOCUMENTS_COMPARE}/:id`, {id: encodeURIComponent(id)});
};

// MGA DASHBOARD

export const RETAIL_CLIENTS = 'retailers';
export const RETAIL_CLIENT = 'retailer';
export const AGENCY_STATUSES = 'agency-statuses';

export const ENNABL_MGA_DASHBOARD = '/dashboard';
export const MGA_DASHBOARD_MARKETS = `${ENNABL_MGA_DASHBOARD}/${MARKETS}`;
export const MGA_DASHBOARD_MARKET = `${ENNABL_MGA_DASHBOARD}/${MARKET}`;
export const MGA_DASHBOARD_RETAIL_CLIENTS = `${ENNABL_MGA_DASHBOARD}/${RETAIL_CLIENTS}`;
export const MGA_DASHBOARD_RETAIL_CLIENT = `${ENNABL_MGA_DASHBOARD}/${RETAIL_CLIENT}`;
export const MGA_DASHBOARD_PRODUCERS = `${ENNABL_MGA_DASHBOARD}/${PRODUCERS}`;
export const MGA_DASHBOARD_PRODUCER = `${ENNABL_MGA_DASHBOARD}/${PRODUCER}`;
export const MGA_DASHBOARD_REPORTS = `${ENNABL_MGA_DASHBOARD}/${REPORTS}`;

export const DASHBOARD_RETAIL_CLIENT_URL = `${MGA_DASHBOARD_RETAIL_CLIENT}/:id`;
export const DASHBOARD_PRODUCER_URL = `${MGA_DASHBOARD_PRODUCER}/:id`;
export const DASHBOARD_MARKET_URL_BASE = `${MGA_DASHBOARD_MARKET}/:category/:id`;

export function generateDashboardRetailClientPath(pathProps: DecisionsPathProps) {
  return generateDecisionsPath({...pathProps, url: DASHBOARD_RETAIL_CLIENT_URL});
}

export function generateDashboardProducerPath(pathProps: DecisionsPathProps) {
  return generateDecisionsPath({...pathProps, url: DASHBOARD_PRODUCER_URL});
}

function generateDashboardMarketPath(params: {id: string; category: MarketCategory}) {
  return generatePath(DASHBOARD_MARKET_URL_BASE, {
    ...params,
    id: encodeURIComponent(params.id),
  });
}

export function generateDashboardUltimateCarrierPath(pathProps: ComplexPathIdProps) {
  return generateDashboardMarketPath({
    id: pathProps.id,
    category: MarketCategory.ULTIMATE,
  });
}

export function generateDashboardParentCarrierPath(pathProps: ComplexPathIdProps) {
  return generateDashboardMarketPath({
    id: pathProps.id,
    category: MarketCategory.PARENT,
  });
}

export function generateDashboardIssuingPaperCarrierPath(pathProps: ComplexPathIdProps) {
  return generateDashboardMarketPath({
    id: pathProps.id,
    category: MarketCategory.CHILD,
  });
}

export const mgaCarrierPathGenByType = {
  [CompanyViewType.UltimateParentCarrier]: generateDashboardUltimateCarrierPath,
  [CompanyViewType.ParentCarrier]: generateDashboardParentCarrierPath,
  [CompanyViewType.IssuingPaper]: generateDashboardIssuingPaperCarrierPath,
};

export const mgaCarrierViewTypes = [
  CompanyViewType.UltimateParentCarrier,
  CompanyViewType.ParentCarrier,
  CompanyViewType.IssuingPaper,
];

export function generateDashboardCustomReportPath({
  reportType,
  mode,
  ...pathProps
}: DecisionsPathProps & {
  reportType: CustomReportType;
  mode?: CustomReportMode;
}) {
  return generateDecisionsPath({
    ...pathProps,
    url: `${MGA_DASHBOARD_REPORTS}/${CUSTOM_REPORT}/:id`,
    searchParams: compact([{key: 'type', value: reportType}, mode && {key: 'mode', value: mode}]),
  });
}

export function generateDashboardQueryReportPath(id: string) {
  return generateDecisionsPath({
    id,
    url: `${MGA_DASHBOARD_REPORTS}/${QUERY_REPORT}/:id`,
  });
}

// SETTINGS

export const ENNABL_SETTINGS = '/settings';
export const USERS = 'users';
export const ROLES = 'roles';
export const USER_ENVIRONMENTS = 'user-environments';
export const NEW_ID_STUB = 'new';

export const ENNABL_SETTINGS_USERS = `${ENNABL_SETTINGS}/${USERS}`;
export const ENNABL_SETTINGS_ROLES = `${ENNABL_SETTINGS}/${ROLES}`;
export const ENNABL_SETTINGS_USER_ENVIRONMENTS = `${ENNABL_SETTINGS}/${USER_ENVIRONMENTS}`;

export const ENNABL_SETTINGS_USER_URL = `${ENNABL_SETTINGS_USERS}/:id`;
export const ENNABL_SETTINGS_ROLE_URL = `${ENNABL_SETTINGS_ROLES}/:id`;
export const ENNABL_SETTINGS_USER_ENVIRONMENT_URL = `${ENNABL_SETTINGS_USER_ENVIRONMENTS}/:id`;

export const DATA_MANAGEMENT = 'data-management';
export const UPLOAD = 'upload';
export const ADMIN = 'admin';
export const USER = 'user';
export const ENNABL_SETTINGS_DATA_MANAGEMENT = `${ENNABL_SETTINGS}/${DATA_MANAGEMENT}`;
export const ENNABL_SETTINGS_DATA_MANAGEMENT_ADMIN = `${ENNABL_SETTINGS_DATA_MANAGEMENT}/${ADMIN}`;
export const ENNABL_SETTINGS_DATA_MANAGEMENT_USER = `${ENNABL_SETTINGS_DATA_MANAGEMENT}/${USER}`;
export const ENNABL_SETTINGS_DATA_MANAGEMENT_UPLOAD = `${ENNABL_SETTINGS_DATA_MANAGEMENT_USER}/${UPLOAD}`;
export const ENNABL_SETTINGS_DATA_MANAGEMENT_UPLOAD_URL = `${ENNABL_SETTINGS_DATA_MANAGEMENT_UPLOAD}/:id`;
export const ENNABL_SETTINGS_DATA_MANAGEMENT_ADMIN_AGENCY_URL = `${ENNABL_SETTINGS_DATA_MANAGEMENT_ADMIN}/:externalSystemId`;
export const ENNABL_SETTINGS_DATA_MANAGEMENT_ADMIN_AGENCY_UPLOAD_URL = `${ENNABL_SETTINGS_DATA_MANAGEMENT_ADMIN_AGENCY_URL}/${UPLOAD}/:id`;

export function generateSettingsDataManagementUploadPath(id: string) {
  return `${ENNABL_SETTINGS_DATA_MANAGEMENT_UPLOAD}/${encodeURIComponent(id)}`;
}

export function generateSettingsDataManagementAdminAgencyPath(id: string) {
  return `${ENNABL_SETTINGS_DATA_MANAGEMENT_ADMIN}/${encodeURIComponent(id)}`;
}

export function generateSettingsDataManagementAdminAgencyUploadPath(externalSystemId: string, uploadId?: string) {
  const uploadPath = `${generateSettingsDataManagementAdminAgencyPath(externalSystemId)}/${UPLOAD}`;

  return uploadId ? `${uploadPath}/${encodeURIComponent(uploadId)}` : uploadPath;
}

export function generateSettingsUserPath(pathProps: Omit<GeneratePathProps, 'url'> = {id: NEW_ID_STUB}) {
  return generateDecisionsPath({...pathProps, url: ENNABL_SETTINGS_USER_URL});
}

export function generateSettingsRolePath(pathProps: Omit<GeneratePathProps, 'url'> = {id: NEW_ID_STUB}) {
  return generateDecisionsPath({...pathProps, url: ENNABL_SETTINGS_ROLE_URL});
}

export function generateSettingsUserEnvironmentPath(pathProps: Omit<GeneratePathProps, 'url'> = {id: NEW_ID_STUB}) {
  return generateDecisionsPath({...pathProps, url: ENNABL_SETTINGS_USER_ENVIRONMENT_URL});
}
